"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _admin = require("../../selectors/admin.js");
var _admin2 = require("../../reducers/admin.js");
var _MessagingComponent = _interopRequireDefault(require("./MessagingComponent"));
var _withMessageList = _interopRequireDefault(require("./withMessageList"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    projectLinks: (0, _admin.getProjectLinks)(state.assignment.admin),
    breadcrumbs: (0, _admin.getDeploymentBreadcrumbs)(state.assignment.admin, props),
    deployment: (0, _admin.getDeploymentById)(state.assignment.admin, props)
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps, {
  deleteMessage: _admin2.deleteMessage,
  unscheduleMessage: _admin2.unscheduleMessage,
  reloadCurrentProject: _admin2.reloadCurrentProject
})((0, _withMessageList["default"])(_MessagingComponent["default"]));
exports["default"] = _default;